import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const deleteAccountPassword = createAsyncThunk("AgentPasswords/deleteAccountPassword", async (data, thunkAPI) => {
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_BASE_URL}api/users/passwords/${data.id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { ...resp.data, deletedId: data.id };
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
